var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.catalog)?_c('div',{staticClass:"Main-Content"},[_c('ImportModal',{attrs:{"catalog-id":_vm.catalog.id,"visible":_vm.showModal},on:{"close":function($event){_vm.showModal = false},"upload":_vm.onFinishUpload}}),_c('Page',{attrs:{"title":_vm.catalog.name,"breadcrumbs":[
      {
        label: _vm.$t('Recommendations.catalogs'),
        onAction: function () { return _vm.$router.push({name: 'AccountRecCatalogs'}); }
      }
    ],"primary-action":{
      label: _vm.$t('Recommendations.importCatalog'),
      onAction: _vm.startImport
    },"secondary-actions":[
      {
        label: _vm.$t('Refresh'),
        onAction: _vm.refreshList
      }
    ],"size":"fullWidth"}},[_c('Card',[_c('CardSection',[_c('Stats',[_c('Stat',{attrs:{"label":_vm.$t('ID'),"value":_vm.catalog.id}}),_c('Stat',{attrs:{"label":_vm.$t('Domain'),"value":_vm.catalog.domain}}),_c('Stat',{attrs:{"label":_vm.$t('Currency'),"value":_vm.catalog.currencyCode}}),_c('Stat',{attrs:{"label":_vm.$t('Language'),"value":_vm.catalog.languageCode}}),_c('Stat',{attrs:{"label":_vm.$t('Recommendations.totalItems'),"value":_vm.catalog.uniqueItemsFp,"type":"integer"}})],1)],1)],1),_c('Card',{attrs:{"title":_vm.$t('Recommendations.imports')}},[_c('DataTable',{attrs:{"loading":_vm.isLoadingList,"columns":[
          {
            key: 'importId',
            label: _vm.$t('ID')
          },
          {
            key: 'createdOn',
            label: _vm.$t('Date'),
            format: 'dateTimeShort'
          },
          {
            key: 'state',
            label: _vm.$t('State')
          },
          {
            key: 'filename',
            label: _vm.$t('Recommendations.filename')
          },
          {
            key: 'source',
            label: _vm.$t('Source')
          },
          {
            key: 'totalCount',
            label: _vm.$t('Recommendations.itemCount'),
            format: 'integer'
          },
          {
            key: 'googleSuccessCount',
            label: _vm.$t('Recommendations.successCount'),
            format: 'integer'
          },
          {
            key: 'googleFailureCount',
            label: _vm.$t('Recommendations.failedCount'),
            format: 'integer'
          }
        ],"rows":_vm.imports,"row-actions":_vm.rowActionFn,"pagination":{
          offset: _vm.offset,
          limit: _vm.limit,
          total: _vm.imports.length,
          updateOffset: function (val) { return _vm.offset = val; },
          updateLimit: _vm.updateLimit
        }},scopedSlots:_vm._u([{key:"col:importId",fn:function(ref){
        var value = ref.value;
return [_c('abbr',{attrs:{"title":value}},[_vm._v(_vm._s(value.split('-')[0]))])]}},{key:"col:state",fn:function(ref){
        var value = ref.value;
return [(value === 'failed')?_c('Badge',{attrs:{"status":"warning"}},[_vm._v(_vm._s(_vm.$t(("Recommendations." + value))))]):(value === 'completed')?_c('Badge',{attrs:{"status":"success"}},[_vm._v(_vm._s(_vm.$t(("Recommendations." + value))))]):_c('Badge',{attrs:{"status":"info"}},[_vm._v(_vm._s(_vm.$t(("Recommendations." + value))))])]}},{key:"col:source",fn:function(ref){
        var value = ref.value;
return [_vm._v("\n          "+_vm._s(_vm.$t(("Recommendations." + value)))+"\n        ")]}}],null,false,380909436)})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }